import React from "react";
import styles from "./InputFieldFormArray.module.css";

function InputFieldForm({ label, fieldRef, name, type, id, placeholder }) {
  return (
    <article className={styles["form-input"]}>
      <fieldset>
        <legend>{label}</legend>
        <input
          placeholder={placeholder}
          className={styles["input-field-form"]}
          {...fieldRef}
          name={name}
          type={type}
          id={id}
        />
      </fieldset>
    </article>
  );
}

export default InputFieldForm;
